import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { StandaloneInstructions } = await import('./index');
    return {
        Component: StandaloneInstructions,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
